import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ExtensionsService {
    private host = environment.apiUrl + '/v1/extensions/';

    getImageUrl(imagePath: string): string {
        return this.host + imagePath;
    }
}
